import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import type { OrganizationViewMode } from '../interfaces';

interface IOrganizationsFooterProps {
  viewMode: OrganizationViewMode;
  visibleCount: number;
  totalCount: number;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export const OrganizationsFooter: React.FC<IOrganizationsFooterProps> = ({
  viewMode,
  visibleCount,
  totalCount,
  onPrevPage,
  onNextPage,
}) => (
  <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
      Showing{' '}
      <Typography component="span" variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>
        1 to {visibleCount}
      </Typography>{' '}
      of {totalCount} organizations
    </Typography>
    {viewMode === 'grid' && (
      <Stack direction="row" spacing={1}>
        <Button
          onClick={onPrevPage}
          variant="outlined"
          size="small"
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2 }}
        >
          Previous
        </Button>
        <Button
          onClick={onNextPage}
          variant="contained"
          size="small"
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2 }}
        >
          Next
        </Button>
      </Stack>
    )}
  </Box>
);
